import {
  isDateAfterTodayOrEqual,
  isDateBeforeTodayOrEqual,
} from "@/module/Utils/DateTimeHelpers";
import FormItemPriceData from "@/module/FormItemPriceData";
import FormItemPriceMetadata from "@/module/FormItemPriceMetadata";

export default class FormItemPrice implements FormItemPriceData {
  readonly currency_code: string;
  readonly metadata: FormItemPriceMetadata | null;
  readonly price: number;
  readonly type: string;
  readonly repayment_count: number | null;

  constructor(itemPrice: FormItemPriceData) {
    this.price = itemPrice.price;
    this.type = itemPrice.type;
    this.currency_code = itemPrice.currency_code;
    this.metadata = itemPrice.metadata ?? null;
    this.repayment_count = itemPrice.repayment_count ?? null;
  }

  public isSpecialPriceDateInRange(): boolean {
    if (this.metadata === null) {
      return true;
    }

    const dates = this.metadata.special_price;
    let isBeginningInRange = true;
    let isEndInRange = true;

    if (dates.begin_date !== null) {
      const beginDate = new Date(dates.begin_date);

      isBeginningInRange = isDateBeforeTodayOrEqual(beginDate);
    }

    if (dates.end_date !== null) {
      const endDate = new Date(dates.end_date);

      isEndInRange = isDateAfterTodayOrEqual(endDate);
    }

    return isBeginningInRange && isEndInRange;
  }
}
